// extracted by mini-css-extract-plugin
module.exports = {"userBoxItem":"UserBoxItem_userBoxItem__2mjBc","userBoxLink":"UserBoxItem_userBoxLink__2MpC7"};